<p-menubar [model]='topbarMenuConfig' [ngClass]='{"colorized": colorizedMenu}' class='py-5 px-4 mx-4 md:mx-6 lg:mx-8 lg:px-8'>
  <ng-template pTemplate='start'>
    <a class='flex align-items-center mx-9' href='#'>
      <img [src]='colorizedMenu ? "assets/layout/images/iPensii-white.svg" : "assets/layout/images/iPensii-new.svg"'
           alt='iPensii Logo' class='logo-height mr-0 lg:mr-2'>
    </a>
  </ng-template>
</p-menubar>
